import { render, staticRenderFns } from "./InstituteChainEdit.vue?vue&type=template&id=14159f2c"
import script from "./InstituteChainEdit.vue?vue&type=script&lang=js"
export * from "./InstituteChainEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports